var _templateObject;
var _excluded = ["children", "className", "dotsClass", "prevArrow", "nextArrow", "swipe", "lazyLoad", "autoplaySpeed", "slidesToShow", "responsive", "infinite"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import Slider from '@domain-group/react-slick';
import ChevronleftIcon from '@domain-group/fe-co-icon/lib/js/chevron-left';
import ChevronRightIcon from '@domain-group/fe-co-icon/lib/js/chevron-right';
import { ClassNames } from '@emotion/core';
import carousel from './carousel.style';
import dots from './dots.style';
import NavigationButton from './navigation-button';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Carousel = /*#__PURE__*/forwardRef((_ref, ref) => {
  var children = _ref.children,
    className = _ref.className,
    dotsClass = _ref.dotsClass,
    _ref$prevArrow = _ref.prevArrow,
    prevArrow = _ref$prevArrow === void 0 ? ___EmotionJSX(NavigationButton, {
      NavIcon: ChevronleftIcon
    }, "Previous") : _ref$prevArrow,
    _ref$nextArrow = _ref.nextArrow,
    nextArrow = _ref$nextArrow === void 0 ? ___EmotionJSX(NavigationButton, {
      NavIcon: ChevronRightIcon
    }, "Next") : _ref$nextArrow,
    _ref$swipe = _ref.swipe,
    swipe = _ref$swipe === void 0 ? true : _ref$swipe,
    _ref$lazyLoad = _ref.lazyLoad,
    lazyLoad = _ref$lazyLoad === void 0 ? true : _ref$lazyLoad,
    _ref$autoplaySpeed = _ref.autoplaySpeed,
    autoplaySpeed = _ref$autoplaySpeed === void 0 ? 3000 : _ref$autoplaySpeed,
    _ref$slidesToShow = _ref.slidesToShow,
    slidesToShow = _ref$slidesToShow === void 0 ? 1 : _ref$slidesToShow,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? [] : _ref$responsive,
    _ref$infinite = _ref.infinite,
    infinite = _ref$infinite === void 0 ? false : _ref$infinite,
    carouselProps = _objectWithoutProperties(_ref, _excluded);
  var sliderRef = useRef(null);
  useImperativeHandle(ref, () => ({
    goTo: index => {
      var _sliderRef$current;
      if (sliderRef.current && (_sliderRef$current = sliderRef.current) !== null && _sliderRef$current !== void 0 && _sliderRef$current.slickGoTo) {
        sliderRef.current.slickGoTo(index);
      }
    }
  }));
  return ___EmotionJSX("div", {
    className: className,
    css: carousel
  }, ___EmotionJSX(ClassNames, null, _ref2 => {
    var css = _ref2.css;
    return ___EmotionJSX(Slider, _extends({
      ref: sliderRef,
      swipe: swipe,
      lazyLoad: lazyLoad,
      slidesToShow: slidesToShow,
      autoplaySpeed: autoplaySpeed,
      responsive: responsive,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      infinite: infinite
    }, carouselProps, {
      dotsClass: dotsClass || css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                  ", ";\n                "])), dots)
    }), children);
  }));
});
export default Carousel;